const aboutNavData = {
	navTitle: 'About HJ',
	navTitleLink: 'https://www.69work.com/',
	navLinks: [
		{ link: 'Jane\'s Story', href: '/about-jane/' },
		{ link: 'Mission + Values', href: '/about' },
		{ link: 'Wishlist', href: '/wishlist' },
		{ link: 'Become a Seller', href: '/sell' },
	],
	btnText: 'Marketplace',
	btnLink: 'https://www.69work.com/marketplace',
};

export default aboutNavData;
